import { render } from "./CustomerDueReceiveList.vue?vue&type=template&id=5f862b16"
import script from "./CustomerDueReceiveList.vue?vue&type=script&lang=js"
export * from "./CustomerDueReceiveList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__